module.exports = __webpack_public_path__ + "54cb408cd947ee2c5082298c6fdf612f.svg";